/* eslint max-lines: 0 */

/**
 * Global styles get added in the wrong order when using styled-components.
 * Exporting the styles from this file is the current workaround to this issue.
 * https://github.com/ben-rogerson/twin.macro/issues/277#issuecomment-754240911
 */

import React from "react"
import tw, { GlobalStyles, css } from "twin.macro"
import { createGlobalStyle } from "styled-components"
import { SystemFonts, ThemeFontFamilyTokens, ThemeFontSizeTokens } from "./fonts"
import { SystemColorTokens, ThemeColorTokens } from "./colors"
import { ButtonStyles } from "./buttons"

const NftBarStyle = createGlobalStyle` 
   html,
   body{
    ${css`
      .nextui-tooltip-button {
        display: -webkit-inline-box;
        color: #b9d1ff;
      }
      .phoneInput {
        height: 45px !important;
        font-family: Jeko !important;
      }
      .inputFull {
        width: 100% !important;
      }
      ,
      .react-tel-input .phoneInput,
      .flag-dropdown {
        font-family: Jeko !important;
        font-size: 16px;
      }
      .greenCheckbox {
        svg {
          height: 16px;
        }
        path,
        circle {
          stroke: #7fe250;
        }
      }
    `}
   
   }
 `
export enum BonsaiTheme {
  Light = "light",
  Dark = "dark",
}

const ThemeCommon = createGlobalStyle`
  ${css`
    html,
    body {
      ${tw`bg-background text-body-color font-sans text-md font-normal relative min-h-screen`}
      a {
        ${tw`
          text-link-color no-underline
        `};
        @media (hover: hover) and (pointer: fine) {
          ${tw`hover:(underline cursor-pointer)`}
        }
      }
    }
    #root,
    #__next {
      ${tw`relative min-h-screen`}
      ${tw`flex flex-col`}
      color-scheme: only light;
    }
    :root {
      pre {
        ${tw`
          bg-system-gray-1 rounded-md px-3 py-2 text-system-red-2 tablet:whitespace-pre-wrap overflow-scroll 
        `};
        code {
          ${tw`
            text-system-red-3 block font-medium
          `};
        }
      }
      code {
        ${tw`
          bg-system-gray-1 rounded-sm px-1 py-0.5 text-system-red-3 font-medium text-sm
        `};
      }
      table {
        tr {
          ${tw`align-top`}
        }
        th,
        td {
          ${tw`py-3 text-left`}
        }
      }
      .content {
        pre {
          ${tw`
            my-4
          `};
        }
      }
    }
  `}
`

const ThemeDark = createGlobalStyle`
  ${css`
    [data-theme=${BonsaiTheme.Dark}] {
      html,
      body {
        ${tw`bg-background text-body-color font-sans text-md font-normal`}
        a {
          ${tw`
            text-link-color no-underline
          `};
          @media (hover: hover) and (pointer: fine) {
            ${tw`hover:(underline cursor-pointer)`}
          }
        }
      }

      pre {
        ${tw`
          bg-base-5 text-system-blue-3
        `};
        code {
          ${tw`
            text-system-blue-3
          `};
        }
      }
      code {
        ${tw`
          bg-base-5 text-system-blue-3
        `};
      }
    }
  `},
`

export default function GlobalStylesComponent() {
  return (
    <>
      <SystemFonts />
      <SystemColorTokens />
      <ThemeFontFamilyTokens />
      <ThemeFontSizeTokens />
      <ThemeColorTokens />
      <ButtonStyles />
      <ThemeCommon />
      <ThemeDark />
      <NftBarStyle />
      <GlobalStyles />
    </>
  )
}
